import { render, staticRenderFns } from "./DateSeparator.vue?vue&type=template&id=8bc8d1ac&"
import script from "./DateSeparator.ts?vue&type=script&lang=ts&"
export * from "./DateSeparator.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports